export const fileLog = function (item = null) {
    return {
        id: item == null ? null : item.id,
        filename: item == null ? null : item.filename
    };
};
